module.exports = __webpack_public_path__ + "static/media/fender-bender.4b593321.svg";